import { ColumnWrapper, Description, Info, Title } from '../footer.style'

export const Partner = () => {
    return (
        <ColumnWrapper>
            <Title>Légy a partnerünk!</Title>
            <Description>Hirdesd te is eseményeidet nálunk! Keres minket a következő elérhetőségek valamelyikén:</Description>
            <Info>+36 30 074 3731</Info>
            <Info>marton.ticket@gmail.com</Info>
        </ColumnWrapper>
    )
}
